<div class="row">
  <div class="col-lg-12">
    <div class="form-group">
      <div style="text-align: center">
        <div id="qrcode" style="margin-top:10px;"></div>
      </div>

    </div>
  </div>

</div>


// WEBPACK FOOTER //
// ./src/app/member/create-qrcode/create-qrcode.component.html